import styled from '@emotion/styled'
import { Box, Theme } from '@mui/material'

export const MenuContainer = styled(Box)<{ theme?: Theme }>`
  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: center;
  /* Target the icon color for hover state */
  a {
    &:hover .navigation-icon {
      color: ${({ theme }) => theme?.palette.secondary.main} !important;
    }
  }
`

export const VerticalMenuSeparator = styled(Box)<{ theme?: Theme }>`
  width: 1px;
  height: 50%;
  background-color: ${({ theme }) => theme.palette.secondary.contrastText};
`
